<style lang="less" scoped>
*{margin: 0;list-style-type:none;}
.center{width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;}
.periodical{width: 1150px; margin: 0px auto; display: flex;flex-direction: column;margin-bottom: 20px;}
i{float: left;margin-top: -1px;margin-right: 8px;font-size: 20px;color: rgb(25, 159, 248);}
.logo{align-self: start;margin-top: 20px;
  span{font-size: 18px;color: rgb(49, 49, 49);}
}
.main{width: 1130px; margin: 0px auto; margin-left: 20px; display: flex;flex-direction: column;margin-bottom: 20px;}
.type{margin-top: 20px;margin-bottom:20px;
  .left{float: left;
    span{font-size: 18px;font-weight: 600;}}
  .right{float: right;cursor: pointer;
    span{font-size: 16px;font-weight: 600;color: rgb(49, 49, 49);}
    img{vertical-align: bottom;}
  }
}
ul{list-style: none;
  li{display: flex;margin-left: -40px;height: 100px;}
  li:last-child{border-bottom: 2px solid rgb(223, 222, 222);}
  li:hover{cursor: pointer;
    .title{color:rgb(53, 132, 196);}
  }
  img{width: 100px;height:80px;margin-right: 20px;}
  p{margin-top: 30px;white-space: nowrap; overflow: hidden; text-overflow:ellipsis;}
  .title{width: 420px;text-align: left;margin-right: 40px;}
  .author{width: 300px;text-align: left;margin-right: 40px;}
  .pdf{width: 60px;margin-right: 60px;margin-top: 5px;margin-top: 33px;}
}

</style>
<template>
  <div class="center">
    <div class="periodical">
      <div class="logo">
        <i class="iconfont icon-zixun"></i><span>东盟各国投资手册</span>
      </div>
      <div class="main">
        <div class="type" v-if="flag1">
          <div class="left">
            <span>老挝</span>
          </div>
        </div>
        <ul class="catalogue">
          <li v-for="(item, index) in List" :key="index" @click="lookPDF(item.pdf)">
            <img :src="item.thumb" />
            <p class="title">{{ item.title }}</p>
            <p class="author">{{ item.author }}</p>
            <p class="pdf"><i class="iconfont icon-pdf" style="color: #FF5562"></i>PDF</p>
            <p class="time">{{ item.addtime * 1000 | formatDateYM() }}</p>
          </li>
        </ul>
      </div>
      <div class="block">
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange(this.form.count)"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="countSum">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 东盟地学 罗志远
 */
import filters from '../method/filter'
export default {
  name: '',
  mixins: [filters],
  data()
  {
    return {
      catid: null,
      List: [],
      flag1: false,
      count: 10,
      pageSize: 10,
      currentPage: 1,
      countSum: null
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        if (+nval.query.catid === 427)
          this.flag1 = true
        this.catid = +nval.query.catid
        this.getList()
      },
      immediate: true
    }
  },
  methods:
  {
    //获取数据
    getList()
    {
      let count = this.count
      let currentPage = this.currentPage
      let paras = {cmd: 'query', _major: 11, _minor: 67, _exp: `catid=${this.catid} and examine = 0`, init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: 'addtime DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.countSum = ret[0].total
        this.List = []
        ret[0].data.forEach(item =>
        {
          this.List.push({
            id: item.id,
            title: item.title,
            thumb: item.thumb ? item.thumb : 'static/images/moren.jpg',
            author: item.author,
            pdf: item.pdf,
            addtime: item.addtime
          })
        })
      })
    },
    //查看pdf文件
    lookPDF(url)
    {
      if (localStorage.getItem('username'))
        window.open(url, '_blank')
      else
        this.$message({message: '请先登录后再查看文件内容', type: 'error', customClass: 'mzindex'})
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/plugins/app/project/DMinvestmentList.vue